import '@/global.css';
import { StatusBar } from 'expo-status-bar';
import 'react-native-reanimated';

import ProviderContent from '@/components/provider-content';
import { RootInitializer } from '@/components/root-initializer';
import { useThemeColor } from '@/hooks/use-theme-color';
import { initSentry } from '@/lib/sentry';
import * as Sentry from '@sentry/react-native';
import { Stack } from 'expo-router';
import { StyleSheet, View } from 'react-native';
import { HeaderProvider, useHeaderContext } from '@/components/header-context';
import { AnimatedHeader } from '@/components/animated-header';

// Initialize Sentry
initSentry();

function LayoutContent() {
  const { headerTranslateY } = useHeaderContext();
  const backgroundColor = useThemeColor({}, 'background');

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <Stack screenOptions={{ contentStyle: { flex: 1, backgroundColor: backgroundColor } }}>
          <Stack.Screen name='index' options={{ headerShown: false }} />
          <Stack.Screen name='compare' options={{ headerShown: false }} />
          <Stack.Screen name='benchmarking' options={{ headerShown: false }} />
          <Stack.Screen name='admin' options={{ headerShown: false }} />
          <Stack.Screen name='forgot-password' options={{ headerShown: false }} />
          <Stack.Screen name='faq' options={{ headerShown: false }} />
        </Stack>
        <AnimatedHeader translateY={headerTranslateY} />
        <StatusBar style='auto' />
      </View>
    </View>
  );
}

export default Sentry.wrap(function RootLayout() {
  return (
    <RootInitializer>
      <head>
        <title>PangeX</title>
      </head>
      <ProviderContent>
        <HeaderProvider>
          <LayoutContent />
        </HeaderProvider>
      </ProviderContent>
    </RootInitializer>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    overflow: 'hidden',
  },
  content: {
    flex: 1,
    width: '100%',
  },
});
